import { linesToList } from "~/common/utils"

export type RecreateProductInfo = {
  name: string
  category: string
  targetUsers: string
  sellingPoints: string
}

export const getRecreateProductInfo = (
  info?: API.Task.OptimizeProductInfo | null,
): RecreateProductInfo => ({
  name: info?.title || "",
  category: info?.category || "",
  targetUsers: info?.target_audience?.join("、") || "",
  sellingPoints: info?.selling_points?.join("\n") || "",
})

export const buildRecreateProductInfo = (
  info: RecreateProductInfo,
): API.Task.OptimizeProductInfo => ({
  title: info.name.trim(),
  category: info.category.trim(),
  target_audience: linesToList(info.targetUsers.replace(/[、，,；;]/g, "\n")),
  selling_points: linesToList(info.sellingPoints),
})
